import { Link } from "react-router-dom";
import { useConsent } from "../../consent/useConsent";
import "./AppFooter.scss";

// Pätička podľa návrhu triferis-landing: logo a jeden riadok s kontaktom,
// pod ním odkazy na právne dokumenty a nastavenia cookies.
function AppFooter() {
  const { openSettings } = useConsent();

  return (
    <footer className="app-footer">
      <div className="app-footer__wrap">
        <img
          src="/pictures/triferis/triferis-logo-horizontal-on-dark.svg"
          alt="Penzión Triferis"
          className="app-footer__logo"
        />
        <div className="app-footer__text">
          Penzión Triferis · Bystrá 118, 977 01 Bystrá ·{" "}
          <a href="mailto:info@triferis.sk">info@triferis.sk</a> ·{" "}
          <a href="tel:+421 944 526 240">+421 944 526 240</a>
          <div className="app-footer__legal">
            <Link to="/ochrana-osobnych-udajov">Ochrana osobných údajov</Link> ·{" "}
            <Link to="/cookie-politika">Cookies</Link> ·{" "}
            <Link to="/vseobecne-obchodne-podmienky">Všeobecné podmienky</Link> ·{" "}
            <button type="button" className="app-footer__cookies" onClick={openSettings}>
              Nastavenia cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default AppFooter;
